import { useNavigate } from "react-router-dom";
import { Table, Space, Badge, Tooltip } from "antd";
import { ApartmentOutlined } from "@ant-design/icons";

import LockCloseIcon from "@/icons/LockClosedIcon";

import CustomLink from "@/components/ui/CustomLink";
import EmployeeProfile from "@/components/cards/EmployeeProfile";
import ContextMenu from "@/components/containers/ContextMenu";
import ExpandableText from "@/components/views/ObjectFieldValue/ExpandableText";

import routes from "@/routes";
import CheckIcon from "@/icons/CheckIcon";

// Таблица отделов
// Содержит список с возможностью сортировки
// Тут можно настроить колонки и ContentMenu
const UnitsTable = ({
  data,
  loading,
  pagination,
  onChange,
  onEditItem,
  onDeleteItem,
  showActions = true,
  scroll = { x: "100%" },
}) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 1,
      },
      render: (_, { uuid, name }) => (
        <CustomLink to={routes.administration.unitDetail(uuid)}>
          {name}
        </CustomLink>
      ),
    },
    {
      title: "Доступ",
      width: 70,
      align: "center",
      dataIndex: "disallow_parent_access",
      key: "disallow_parent_access",
      render: (disallow_parent_access) =>
        disallow_parent_access && (
          <Tooltip title="Приватная рабочая группа">
            <LockCloseIcon style={{ color: "#BBBBBB", fontSize: 18 }} />
          </Tooltip>
        ),
    },
    {
      title: "Головная организация",
      dataIndex: "is_root",
      key: "is_root",
      align: "center",
      width: 160,
      render: (is_root) =>
        is_root && <CheckIcon style={{ color: "#BBBBBB", fontSize: 18 }} />,
    },
    {
      title: "Тип",
      dataIndex: "unit_type",
      key: "unit_type",
      width: 140,
      ellipsis: true,
      render: (unit_type) => {
        return (
          unit_type && (
            <Space>
              <span>{unit_type.name}</span>
              <Badge
                title="Участвует в оргструктуре"
                count={
                  unit_type.is_hierarchical ? (
                    <ApartmentOutlined
                      style={{
                        color: "var(--color-primary)",
                      }}
                    />
                  ) : (
                    0
                  )
                }
              />
            </Space>
          )
        );
      },
    },

    {
      title: "Родительская РГ",
      dataIndex: "parent",
      key: "parent",
      width: 180,
      ellipsis: true,
      render: (parent) => parent && parent.name,
    },

    {
      title: "Руководитель",
      dataIndex: "manager",
      key: "manager",
      render: (manager) => manager && <EmployeeProfile {...manager} />,
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
      render: (value) => <ExpandableText value={value} line={2} />,
      // width: 200,
    },
    showActions
      ? {
          title: "",
          width: 48,
          align: "center",
          fixed: "right",
          key: "actions",
          render: (_, item) => (
            <ContextMenu
              vertical
              onView={() =>
                navigate(routes.administration.unitDetail(item.uuid))
              }
              onEdit={() => onEditItem(item)}
              onDelete={() => onDeleteItem(item)}
            />
          ),
        }
      : null,
  ].filter(Boolean); // Фильтруем массив, чтобы исключить false значения

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="uuid"
        loading={loading}
        pagination={pagination}
        onChange={onChange}
        showSorterTooltip={{
          target: "sorter-icon",
          title: "Нажмите для сортировки",
        }}
        scroll={scroll}
      />
    </>
  );
};

export default UnitsTable;
